type CookieOptions = number | { expires?: string } | null | undefined;

export const getCookie = (key: string): string | null => {
  if (typeof document === "undefined") return null;
  const name = encodeURIComponent(key) + "=";
  for (const part of document.cookie.split(";")) {
    const trimmed = part.trim();
    if (trimmed.startsWith(name)) return decodeURIComponent(trimmed.substring(name.length));
  }
  return null;
};

export const setCookie = (key: string, value: string, option?: CookieOptions) => {
  if (typeof document === "undefined") return;
  let str = `${encodeURIComponent(key)}=${encodeURIComponent(value)}; path=/`;
  if (typeof option === "number") str += `; Max-Age=${option * 86400}`;
  else if (option?.expires) str += `; Expires=${option.expires}`;
  document.cookie = str + "; Secure; SameSite=Lax";
};

export const deleteCookie = (key: string) => {
  if (typeof document === "undefined") return;
  document.cookie = `${encodeURIComponent(key)}=; Max-Age=0; path=/`;
};

export default { deleteCookie, getCookie, setCookie };
